import { useState } from "react";
import { User } from "types/user";
import { userDisable, userEnable } from "apis/user";

type UserStatusKeys = 'enabled' | 'disabled';

type UserStatus = ( type: UserStatusKeys) => [ boolean, (user: User) => Promise<void> ]

const useUserStatus:UserStatus = type => {

  const [loading, setLoading] = useState<boolean>(false)

  const userStatusApis: { [key in UserStatusKeys]: Function } = {
    'enabled': userEnable,
    'disabled': userDisable,
  }

  const changeUserStatus = (user: User) => {
    setLoading(true)
    return new Promise<void>((resolve, reject) => {
      userStatusApis[type](user.id)
      .then(() => resolve())
      .catch(() => reject())
      .finally(() => setLoading(false))
    })
  }

  return [loading, changeUserStatus]
}

export default useUserStatus;